import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Icon from 'dpl/common/components/Icon';

/** @param {any} props */
export default function Breadcrumbs({ className = null, links }) {
  return (
    <nav
      className={classnames('Breadcrumbs', className)}
      aria-label="Breadcrumbs"
    >
      <ol className="flex items-center flex-wrap gap-x-8 gap-y-4 lh-title font-16 overflow-scroll no-scrollbars">
        {links.map(({ name, url }, index) => {
          const isLastLink = index === links.length - 1;

          return (
            <li
              key={index}
              className="inline-flex items-center gap-8"
              data-test-id={`Breadcrumb--${index}`}
            >
              <a
                className={isLastLink ? 'tertiary' : 'underline'}
                aria-current={isLastLink ? 'page' : null}
                href={url}
              >
                {name}
              </a>
              {!isLastLink && (
                <div aria-hidden="true">
                  <Icon
                    className="tertiary"
                    name="fetch-arrow-right-sm"
                    height="20px"
                    width="20px"
                  />
                </div>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}

Breadcrumbs.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  ).isRequired,
  className: PropTypes.string
};
